import React from 'react';
import AppHeader from "../components/AppHeader";
import Footer from "../components/Footer";
import { Outlet} from 'react-router-dom';


const HomePage = () => {
    return (
        <div>
            <AppHeader />
            <Outlet />

            <Footer />
        </div>
    );
};

export default HomePage;